var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsA: "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    x: "0px",
    y: "0px",
    width: "107px",
    height: "93px",
    viewBox: "-0.4838867 -0.1933594 107 93",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M106.3305664,0H0v91.9970703h106.3305664V0z M101.7016602,87.2851563H4.6191406V4.6240234h97.0825195 V87.2851563z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M17.7490234,69.4384766l-0.090332,7.2167969c6.6552734-0.3759766,31.3452148-0.3759766,38.6523438,0 l-0.1855469-7.1191406c-10.8154297,0.2734375-9.7998047-2.0410156-9.7998047-5.2734375V50.0244141l13.4033203,15.5273438 c2.5878906,2.96875,4.7216797,6.6601563,7.3046875,10.9179688c24.6875,0,27.734375,0.1855469,27.734375,0.1855469v-6.9384766 C86.8237305,68.9794922,85.5249023,68.2373047,82.7563477,65l-17.109375-20.0585938 c10.6347656-1.2988281,17.2949219-6.8457031,17.1972656-15.8154297 C82.7563477,13.4082031,68.425293,14.0527344,53.2592773,13.7792969 c-5.0854492-0.0976563-29.1235352,0.0878906-35.6005859,0.0878906l0.090332,7.2119141 c9.8950195,0,9.0649414,0.9228516,9.0649414,4.8095703v38.3740234 C26.8139648,66.7578125,28.1054688,70.1806641,17.7490234,69.4384766z M46.3256836,21.640625 c1.4746094-0.0976563,2.7734375-0.2832031,4.1577148-0.2832031c7.3022461,0,11.9262695,2.7783203,11.9262695,8.7890625h-0.0927734 c0.0927734,8.2226563-6.8457031,10.6347656-15.9912109,10.9082031V21.640625z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/R.01529e284ccd70acceb0f3fc69f72f72.svg";
export { ForwardRef as ReactComponent };